import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './theme/index.css';

// @ts-ignore
const root = createRoot(document.getElementById('aasm-root'));
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
